import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userId: localStorage.getItem('userid') || '',
  name: localStorage.getItem('name') || '',
  email: localStorage.getItem('email') || '',
  role: localStorage.getItem('role') || '',
  phone: localStorage.getItem('phone') || '',
  companyName: localStorage.getItem('companyName') || '',
  gstNumber: localStorage.getItem('gstNumber') || '',
  profileImage: localStorage.getItem('profileImage') || '',
  profileImageKey: localStorage.getItem('profileImageKey') || ''
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const {
        userId,
        name,
        email,
        role,
        phone,
        companyName,
        gstNumber,
        profileImage,
        profileImageKey
      } = action.payload || {};
      state.userId = userId || '';
      state.name = name || '';
      state.email = email || '';
      state.role = role || '';
      state.phone = phone || '';
      state.companyName = companyName || '';
      state.gstNumber = gstNumber || '';
      state.profileImage = profileImage || '';
      state.profileImageKey = profileImageKey || '';
    },
    clearUser: (state) => {
      state.userId = '';
      state.name = '';
      state.email = '';
      state.role = '';
      state.phone = '';
      state.companyName = '';
      state.gstNumber = '';
      state.profileImage = '';
      state.profileImageKey = '';
    }
  }
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
